import {Component} from "preact";
import style from './styles.scss';
import {isIE} from "../../../utilities/detectIE";

export default class DropDownMenu extends Component {

    static defaultProps = {
        open: false,
        class: '',
        customStyle: {},
        closeFunction: () => {}
    };

    componentDidUpdate(previousProps, previousState, previousContext) {
        if (previousProps.open === false && this.props.open === true) {
            // if (window.location.hash.length) {
            //     const url = window.location.href;
            //     url.replace(/#\S*/, '#' + Date.now());
            //     window.history.replaceState(window.history.state, null, url);
            // } else {
            //     window.location.hash = '#' + Date.now();
            // }
            setTimeout(() => window.addEventListener('popstate', this.props.closeFunction));
        } else if (previousProps.open === true && this.props.open === false) {
            setTimeout(() => window.removeEventListener('popstate', this.props.closeFunction));
        }
    }

    componentDidMount() {
        this.base.addEventListener('closeDropdown', this.props.closeFunction)
    }

    componentWillUnmount() {
        this.base.removeEventListener('closeDropdown', this.props.closeFunction);
    }

    render(props, state, context) {
        const classes = [
            [style.dropdownContainer],
            props.class,
            props.open && isIE() ? [style.ie] : undefined,
            props.open ? [style.open] : undefined
        ].filter(i => i).join(' ');

        return (
            <div class={classes} style={props.customStyle}>
                {props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/common/dropdown/index.js